import { Component, inject, Input, OnInit, TemplateRef } from '@angular/core';
import { INgxLoadingConfig, ngxLoadingAnimationTypes, NgxLoadingConfig } from './ngx-loading-config';
import { NgxLoadingService } from './ngx-loading.service';
import { NgIf, NgClass, NgStyle, NgSwitch, NgSwitchCase, NgSwitchDefault, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'ngx-loading',
    templateUrl: './ngx-loading.component.html',
    styleUrl: './ngx-loading.component.css',
    imports: [NgIf, NgClass, NgStyle, NgSwitch, NgSwitchCase, NgSwitchDefault, NgTemplateOutlet]
})
export class NgxLoadingComponent implements OnInit {
  @Input() show = false;
  @Input() config: INgxLoadingConfig = new NgxLoadingConfig();
  @Input() template!: TemplateRef<Element>;

  private defaultConfig: INgxLoadingConfig = {
    animationType: ngxLoadingAnimationTypes.threeBounce,
    backdropBackgroundColour: 'rgba(0, 0, 0, 0.3)',
    backdropBorderRadius: '0px',
    fullScreenBackdrop: true,
    primaryColour: '#344AB1',
    secondaryColour: '#ffffff',
    tertiaryColour: '#344AB1',
  };
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  LoadingService = inject(NgxLoadingService)

  constructor() { }

  ngOnInit() {
    this.setupConfig();
  }

  private setupConfig(): void {
    for (const option in this.defaultConfig) {
      if (this.config[option] != null) {
        continue;
      }

      this.config[option] =
        this.LoadingService.loadingConfig[option] != null
          ? this.LoadingService.loadingConfig[option]
          : this.defaultConfig[option];
    }
  }
}
